// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2NP1T","notes":"Notes_notes__1hY_R"};